import React from 'react'

export default function BannerBottom() {
  return (
    <div className='feature-wrap full-container'>
      <div className='container'>
        <div className="row">
            <div className="col-lg-3 text-center col-sm-6 g-sm-4 ms-mobile-p">
                {/* <span>2345+</span> */}
                Digital Process	
            </div>
            <div className="col-lg-3 text-center col-sm-6 g-sm-4 ms-mobile-p">
                {/* <span>2345+</span> */}
              Secure Platform	
            </div>
            <div className="col-lg-3 text-center col-sm-6 g-sm-4 ms-mobile-p">
                {/* <span>2345+</span> */}
              Transparent Charges	
            </div>
            <div className="col-lg-3 text-center col-sm-6 g-sm-4 ms-mobile-p">
                {/* <span>2345+</span> */}
               Customer Support
            </div>
        </div>
      </div>
    </div>
  )
}
